import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import useApiService from '../utilities/useApiService';
import { useLoaderDispatch} from '../context/LoaderContext';
import { startLoading, stopLoading } from '../context/actions/loaderActions';

export const useInitialReports = () => {
  const { getMethod } = useApiService();
  const loaderDispatch = useLoaderDispatch();
  const params: any = useParams();

  const getItems = async () => {
    startLoading(loaderDispatch);
    const response = await getMethod(
      `/pharmacies/${params.pharmacyId}/returnrequests/${params.requestId}/items`
    );
    stopLoading(loaderDispatch);
    return response.data;
  };

  const { data: items = [] } = useQuery('items', getItems);

  const initialReports = items
    .reduce(
      (reports: string[], item: any) => {
        let report = undefined;
        if (item.controlledSubstanceCode.match('3|4|5')) report = 'SCHEDULE-345';
        if (item.controlledSubstanceCode.match('2')) report = 'SCHEDULE-2';
        if (report && !reports.includes(report)) reports.push(report);
        return reports;
      },
      ['INITIAL-REPORT']
    );

  return { initialReports, items };
};
